import React, { useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import QRCodeStyling from "qr-code-styling";
const Root = styled.div``;
const Container = styled.div`
  @media (max-width: 768px) {
    padding: 0 0 0 10px;
  }
  @media (max-height: 480px) {
    display: flex;
    align-items: center;
  }
`;
const BarcodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: white;
  background: transparent;
  border-radius: 10px;
`;
const NewQr = styled.div`
  canvas{
    width: 300px;
    height: auto;
  }
`;
const BarImageWrapper = styled.div`
  /* border: 8px solid #fff; */
  border-radius: 5px;
  margin: 15px 0;
  @media (max-height: 480px) {
    margin: 0;
  }
`;
const Barcode = styled.img``;
const Text = styled.text`
  margin-bottom: 15px;
  font-size: 18px;
  color: white;
  font-weight: 600;
  ${(p) =>
    p.AddressText &&
    `
margin-bottom: 0;
font-size:20px;
`}
`;
const Addresscontainer = styled.div`
  margin: 10px 0;
  padding: 15px 20px;
  width: 100%;
  background-color: #1d1f23;
  border-radius: 10px;
`;
const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  word-wrap: break-word;
  margin: 10px 0 0px 0;
  @media (max-height: 480px) {
    margin: 0;
  }
`;
const CopyIcon = styled.div`
  color: white;
  cursor: pointer;
`;
const Icon = styled.img``;
const AddressText = styled.div`
  word-wrap: break-word;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #969696;
  line-height: 22px;
  margin-top: 10px;
`;
const AddressTextInput = styled.textarea`
  word-wrap: break-word;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  color: #969696;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  line-height: 22px;
  margin-top: 10px;
  text-decoration: none;
  resize: none;
`;
const NoteWrapper = styled.div`
  background: rgba(72, 56, 25, 0.3);
  border-radius: 10px;
  padding: 16px 0;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 168, 0, 0.5);
  line-height: 22px;
  margin: 20px 0 30px 0;
`;
const NoteText = styled.text``;

const SupportWrapper = styled.div`
  padding: 0 20px;
`;
const SupportText = styled.text`
  font-weight: 700;
  text-align: left;
  color: rgb(13 128 155);
  line-height: 50px;
  font-size: 24px;
  font-family: SweraDemo;
`;

const SupportServiceWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  align-items: center;
  background: #212327;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 12px;
  color: #fff;
  padding: 20px 20px;
`;
const TextFAQWrapper = styled.div`
  margin: 0 20px;
`;
// const SupportIconTextWrapper = styled.div`
// display: flex; setLordRatioI(false);
// setImmutureNotePopup(false);
// setMinimumMldNotePopup(false);
// justify-content: space-between;
// align-items:center;

// `;
const QrCodeSection = styled.div`
  canvas {
    height: auto;
    width: 200px;
    @media (max-height: 480px) {
      width: 180px;
  }
  }
`;
const IconWrapper = styled.div``;
const QRcodeTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 0 20px 0;
  background: transparent;
`;
const QRcodeText = styled.div`
  color: #fff;
  font-size: 16px;
`;
const qrCode = new QRCodeStyling({
  width: 200,
  height: 200,
  margin: 0,
  qrOptions: {
    typeNumber: "5",
    mode: "Byte",
    errorCorrectionLevel: "H",
  },
  imageOptions: {crossOrigin:'anonymous', hideBackgroundDots: true, imageSize: 0.2, margin: 0 },
  dotsOptions: {
    type: "classy-rounded",
    color: "#1a1c1f",
    gradient: null,
  },
  backgroundOptions: { color: "#fff", gradient: null },
  image:
    "data:image/png;base64,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",
  dotsOptionsHelper: {
    colorType: { single: true, gradient: false },
    gradient: {
      linear: true,
      radial: false,
      color1: "#1a1c1f",
      color2: "#1a1c1f",
      rotation: "0",
    },
  },
  cornersSquareOptions: { type: "extra-rounded", color: "#6a1a4c" },
  cornersSquareOptionsHelper: {
    colorType: { single: true, gradient: false },
    gradient: {
      linear: true,
      radial: false,
      color1: "#000000",
      color2: "#000000",
      rotation: "0",
    },
  },
  cornersDotOptions: { type: "", color: "#000000" },
  cornersDotOptionsHelper: {
    colorType: { single: true, gradient: false },
    gradient: {
      linear: true,
      radial: false,
      color1: "#000000",
      color2: "#000000",
      rotation: "0",
    },
  },
  backgroundOptionsHelper: {
    colorType: { single: true, gradient: false },
    gradient: {
      linear: true,
      radial: false,
      color1: "#ffffff",
      color2: "#ffffff",
      rotation: "0",
    },
  },
});
// const qrCode = new QRCodeStyling({
//   width: 200,
//   height: 200,
//   margin: 5,
//   // image: whiteCircle,
//   qrOptions: {
//     typeNumber: "0",
//     mode: "Byte",
//     errorCorrectionLevel: "H",
//   },
//   imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
//   dotsOptions: { type: "dots", color: "#000" },
//   backgroundOptions: { color: "#ffffff" },

//   dotsOptionsHelper: {
//     colorType: { single: true, gradient: false },
//     gradient: {
//       linear: true,
//       radial: false,
//       color1: "#000",
//       color2: "#000",
//       rotation: "0",
//     },
//   },
//   cornersSquareOptions: { type: "extra-rounded", color: "#000" },
//   cornersSquareOptionsHelper: {
//     colorType: { single: true, gradient: false },
//     gradient: {
//       linear: true,
//       radial: false,
//       color1: "#000000",
//       color2: "#000000",
//       rotation: "0",
//     },
//   },
//   cornersDotOptions: { type: "", color: "#000" },
//   cornersDotOptionsHelper: {
//     colorType: { single: true, gradient: false },
//     gradient: {
//       linear: true,
//       radial: false,
//       color1: "#000000",
//       color2: "#000000",
//       rotation: "0",
//     },
//   },
//   backgroundOptionsHelper: {
//     colorType: { single: true, gradient: false },
//     gradient: {
//       linear: true,
//       radial: false,
//       color1: "#ffffff",
//       color2: "#ffffff",
//       rotation: "0",
//     },
//   },
// });
const ReceiveTokenTab = ({ address }) => {
  const copyRef = useRef(null);
  // console.log(address,"sadaqweqwsdasd")
  const ref = useRef(null);
  const CopyAddress = () => {
    if (copyRef.current) {
      copyRef.current.select();
      document.execCommand("copy");
      toast.success("Copied !");
      window.getSelection().removeAllRanges();
    }
  };
  useEffect(() => {
    qrCode.append(ref.current);
  }, []);
  useEffect(() => {
    qrCode.update({
      data: address,
    });
  }, [address]);
  return (
    <Root>
      <Container>
        <div>
          <BarcodeWrapper>
            <BarImageWrapper>
              {/* <div className="" ref={ref}></div> */}
              <QrCodeSection ref={ref} />
              {/* <Barcode src={BarcodeIcon}/> */}
              {/* <QRCode
                value={address}
                renderAs="svg"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              /> */}
            </BarImageWrapper>
          </BarcodeWrapper>
          <QRcodeTextWrapper>
            <QRcodeText>Scan the QR code to copy the address</QRcodeText>
          </QRcodeTextWrapper>
        </div>

        {/* <Addresscontainer> */}
          <TextWrapper>
            {/* <Text AddressText>Address </Text> */}
            {/* <CopyIcon onClick={CopyAddress}>
              <i class="fa-solid fa-copy"></i>

              <ToastContainer position="top-right" />
            </CopyIcon> */}
          </TextWrapper>

       <div style={{display:"flex",alignItems:"baseline",gap:"10px"}}>
           <AddressTextInput
            ref={copyRef}
            value={address || "Login First"}
            type="text"
            readOnly
            style={{ fontSize: "13px" }}
          ></AddressTextInput>
            <CopyIcon onClick={CopyAddress}>
              <i class="fa-solid fa-copy"></i>

              <ToastContainer position="top-right" />
            </CopyIcon>
       </div>
        {/* </Addresscontainer> */}
      </Container>
    </Root>
  );
};

export default ReceiveTokenTab;
